import type { SinglePlan } from 'prove-common'

export const countMissingApprovals = (plan: SinglePlan): number => {
  const taskCount = (plan.tasks ?? []).filter(
    (task) => task.analysisTypeApprovalStatus !== 'approved'
  ).length
  const childrenCount = (plan.children ?? []).reduce(
    (sum, child) => sum + countMissingApprovals(child),
    0
  )
  return taskCount + childrenCount
}
